import { useState, type FormEvent } from 'react'

import { Field } from '@/components/ui'
import { ApiError } from '@/lib/api'
import { useAuth } from '@/lib/auth'

export function LoginPage() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function handleSubmit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await signIn(email, password)
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not sign in.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-7 flex items-center gap-3">
          <span
            aria-hidden="true"
            className="flex h-10 w-10 items-center justify-center rounded-lg text-lg font-bold text-white"
            style={{ background: 'var(--series-1)' }}
          >
            K
          </span>
          <div>
            <h1 className="text-lg font-semibold text-ink">LeadConnector</h1>
            <p className="text-sm text-ink-muted">Opportunity matching console</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="card space-y-4 px-5 py-5">
          <Field label="Email">
            <input
              type="email"
              className="field"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="username"
              required
              autoFocus
            />
          </Field>

          <Field label="Password">
            <input
              type="password"
              className="field"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>

          {error && (
            <p
              className="rounded-md px-3 py-2 text-sm"
              style={{
                background: 'color-mix(in srgb, var(--critical) 12%, transparent)',
                color: 'var(--critical)',
              }}
              role="alert"
            >
              {error}
            </p>
          )}

          <button type="submit" className="btn-primary w-full" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="mt-4 text-center text-xs text-ink-faint">
          No account yet? Create one with{' '}
          <code className="rounded bg-raised px-1 py-0.5">python -m app.cli create-admin</code>
        </p>
      </div>
    </div>
  )
}
